import { render, staticRenderFns } from "./addLsDistrib.vue?vue&type=template&id=485d2dda&scoped=true"
import script from "./addLsDistrib.vue?vue&type=script&lang=js"
export * from "./addLsDistrib.vue?vue&type=script&lang=js"
import style0 from "./addLsDistrib.vue?vue&type=style&index=0&id=485d2dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485d2dda",
  null
  
)

export default component.exports